(() => {
  const instances = new WeakMap();
  function setup(root = document) {
    root.querySelectorAll('[data-bb-finder]').forEach(panel => {
      if (instances.has(panel)) return;
      const events = new AbortController();
      instances.set(panel, events);
      panel.addEventListener('click', event => {
        const button = event.target.closest('button[data-bb-game-label]');
        const select = panel.querySelector('[data-bb-game-select]');
        if (!button || !select || select.disabled) return;
        const option = [...select.options].find(option => option.textContent.trim() === button.dataset.bbGameLabel);
        if (!option || select.value === option.value) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      }, {signal: events.signal});
    });

  }
  function close(menu, restoreFocus = false) {
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus();
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-bb-singles-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('[data-bb-singles-menu][open]');
    if (menu) { event.preventDefault(); close(menu, true); }
  });
  const openGameFinder = () => {
    if (location.hash !== '#bb-games') return;
    const menu = document.querySelector('[data-bb-singles-menu]');
    if (menu) menu.open = true;
  };
  window.addEventListener('hashchange', openGameFinder);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { setup(); openGameFinder(); });
  else { setup(); openGameFinder(); }
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bb-finder]').forEach(panel => {instances.get(panel)?.abort(); instances.delete(panel);});
  });
})();
